import { HttpService } from "../index";
import { Storage } from '@ionic/storage';

export class UserService {

    constructor (
        protected httpService:HttpService ,
        protected storage:Storage
        ) {}

    isAdmin() : Promise<boolean> {
        return new Promise<boolean> ((resolve, reject) => {
            this.storage.get('viewersgroup').then((viewersgroup) => {
                resolve(viewersgroup == 'Admin');
            }).catch(() => {
                resolve(false);
            });
        });
    }

    updateUser(user:any) : Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.httpService.put('/api/v1/user', user)
                .then(res => {
                    resolve(res.json());
                }).catch(error => {
                    console.error('User error', error);
                    resolve(null);
                });
        });
    }

    getUser() : Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.httpService.get('/api/v1/user')
                .then(res => {
                    resolve(res.json());
                }).catch(error => {
                    console.error('User error', error);
                    resolve(null);
                });
        });
    }

    login (email, password) : Promise<boolean> {
        return new Promise<boolean> ((resolve, reject) => {
            this.httpService.http.post('/api/v1/user/login', {
                email : email ,
                password : password
            }).subscribe(res => {
                let response = res.json();

                this.storage.clear().then(() => {
                    this.storage.set('token', response.token);
                    this.storage.set('firstname', response.firstname);
                    this.storage.set('lastname', response.lastname);
                    this.storage.set('viewersgroup', response.viewersgroup);
                    resolve(true);
                });
            }, error => {
                console.error('Login Error', error);
                resolve(false);
            });
        });
    }

    logout() : Promise<void> {
        return new Promise<void> ((resolve, reject) => {
            this.httpService.delete('/api/v1/user/logout')
                .then(res => {
                    this.storage.set('token', '');
                    this.storage.set('firstname', '');
                    this.storage.set('lastname', '');
                    this.storage.set('viewersgroup', '');
                    resolve();
                }).catch(() => {
                    reject();
                });
        });
    }

}



// WEBPACK FOOTER //
// ./src/services/user/user-service.ts